/* eslint-disable */
import {Note} from '@ve/components/countryConditions/common/store/types';

import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'CountryConditionItemMobile',
})
export default class CountryConditionItemMixin extends Vue {
    @Prop() readonly note!: Note;

    get isLink(): boolean {
        return !!this.note.link;
    }
}